import React from 'react';
import './Style.css';
import Logo from '../../Assets/Photos/fav_icon.png';
import { Navigation } from '../../Components';
import { BackDropModal } from '../../Modals/Index';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import User from '../../Assets/Photos/Avatar.png';
import { useHistory } from 'react-router';
import { useUser } from '../../Context/User';
const Index = ({ show, toggleShow }) => {
    const isSmallScreen = window.matchMedia('(max-width: 1200px)').matches;
    const hist = useHistory();
    const { role, logout } = useUser();
    return (
        <div className="dashboard_cont">
            {isSmallScreen && show && <BackDropModal close={toggleShow} />}
            <div className={`dashboard ${show ? 'showfocrefully' : ''}`}>
                <div alt="Logo" className="dashboard_logo"></div>
                <div onClick={toggleShow} className={`header_menu ${show ? 'active_menu' : ''}`}>
                    <p className={`header_menu_icon`} />
                </div>
                {role === 'merchant' && (
                    <div className="header_user_sidebar">
                        <div
                            onClick={() => {
                                hist.push('/main/settings/profile');
                            }}
                            className="header_user"
                        >
                            <img src={User} alt="Avatar" className="header_user_image" />
                            <p style={{ fontWeight: 'bold' }} className="header_user_name">
                                Your Profile
                            </p>
                        </div>
                    </div>
                )}
                <Navigation close={toggleShow} />
                <p
                    onClick={async () => {
                        await logout();
                    }}
                    className="dashboard_nav_item ONLYMOBILE"
                >
                    <MeetingRoomIcon className="dashboard_nav_item_icon" />{' '}
                    <p className="dashboard_nav_item_name">Logout</p>
                </p>
            </div>
        </div>
    );
};

export default Index;
